import type { StylePropertiesTypes } from '@wix/document-services-types'
import { getKeywordString } from '../../utils/converterHelpers'
import { BaselineAlignment, PositionalAlignSelf } from '@wix/thunderbolt-becky-root'

/** Internal Converters */
const baselineAlignSelfConverter = (prop: BaselineAlignment) => {
	return `baseline ${prop.order}`
}

const positionalAlignSelfConverter = (prop: PositionalAlignSelf) => {
	return prop.value
}

/** External Mapper */
export const alignSelfConverterMap = {
	Keyword: getKeywordString,
	BaselineAlignment: baselineAlignSelfConverter,
	PositionalAlignment: positionalAlignSelfConverter,
	UnsafePositionalAlignment: positionalAlignSelfConverter,
	SafePositionalAlignment: positionalAlignSelfConverter,
} as Record<string, (prop: StylePropertiesTypes.AlignSelf) => string>
